export default __webpack_public_path__ + "static/media/army_73.32b73409.jpg";